import React from 'react';
import { Layout, Menu, Typography } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  DashboardOutlined,
  UserOutlined,
  TableOutlined,
  BlockOutlined,
  MenuOutlined,
  HomeOutlined,
  VideoCameraOutlined,
  BellOutlined,
  PlayCircleOutlined,
  MoneyCollectOutlined,
  SettingOutlined,
  FileExcelOutlined,
  BarChartOutlined,
  TagsOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined
} from '@ant-design/icons';

const { Sider } = Layout;
const { Title } = Typography;

const Sidebar = ({ collapsed, onCollapse }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      key: '/dashboard/dashboard',
      icon: <DashboardOutlined />,
      label: 'Admin Dashboard',
    },
    {
      key: 'analysis',
      icon: <BarChartOutlined />,
      label: 'Analysis',
      children: [
        {
          key: '/analysis/userAnalysis',
          label: 'User Analysis',
        },
        {
          key: '/analysis/watchedMovieAnalysis',
          label: 'Watched Movie Analysis',
        },
        {
          key: '/analysis/subscriptionsAnalysis',
          label: 'Subscription Analysis',
        },
      ],
    },
    {
      key: 'users',
      icon: <UserOutlined />,
      label: 'Users',
      children: [
        {
          key: '/users/usersByDateRange',
          label: 'Users By Date Range',
        },
        {
          key: '/users/user',
          label: 'User',
        },
        {
          key: '/users/addadmin',
          label: 'Add Admin',
        },
      ],
    },
    {
      key: 'banners',
      icon: <TableOutlined />,
      label: 'Banners',
      children: [
        {
          key: '/banners/banner',
          label: 'Banner',
        },
        {
          key: '/banners/addbanner',
          label: 'Add Banner',
        },
      ],
    },
    {
      key: 'onboarding',
      icon: <BlockOutlined />,
      label: 'OnBoardings',
      children: [
        {
          key: '/onboarding/onboarding-list',
          label: 'OnBoarding List',
        },
      ],
    },
    {
      key: 'categories',
      icon: <MenuOutlined />,
      label: 'Categories',
      children: [
        {
          key: '/categories/category',
          label: 'Categories',
        },
        {
          key: '/categories/addcategory',
          label: 'Add Category',
        },
      ],
    },
    {
      key: 'promo',
      icon: <TagsOutlined />,
      label: 'Promo',
      children: [
        {
          key: '/promo/promo-list',
          label: 'Promo',
        },
        {
          key: '/promo/promo-campaign-list',
          label: 'Promo Campaign',
        },
        {
          key: '/promo/promo-rzp-offer-list',
          label: 'Razorpay Offers',
        },
      ],
    },
    {
      key: 'master',
      icon: <HomeOutlined />,
      label: 'Master',
      children: [
        {
          key: '/master/country',
          label: 'Country',
        },
        {
          key: '/master/currency',
          label: 'Currency',
        },
        {
          key: '/master/videogenre',
          label: 'Genre',
        },
        {
          key: '/master/videolanguage',
          label: 'Language',
        },
        {
          key: '/master/tag',
          label: 'Tag',
        },
        {
          key: '/master/contenttype',
          label: 'Content Type',
        },
        {
          key: '/master/sales_channel',
          label: 'Sales channel',
        },
        {
          key: '/master/faq',
          label: 'FAQs',
        },
        {
          key: '/master/privacy_policy',
          label: 'Privacy Policy',
        },
        {
          key: '/master/terms_conditions',
          label: 'Terms Conditions',
        },
        {
          key: '/master/about_us',
          label: 'About Us',
        },
        {
          key: '/master/mobileappstore',
          label: 'Mobile App Stores',
        },
        {
          key: '/master/contentComplaints',
          label: 'Content Complaints',
        },
        {
          key: '/master/paymentmodes',
          label: 'Payment Mode',
        },
      ],
    },
    {
      key: 'video',
      icon: <VideoCameraOutlined />,
      label: 'Video',
      children: [
        {
          key: '/Video/Quality',
          label: 'Video Quality',
        },
        {
          key: '/Video/ratings',
          label: 'Video Ratings',
        },
      ],
    },
    {
      key: 'subscriptions',
      icon: <BellOutlined />,
      label: 'Subscription',
      children: [
        {
          key: '/subscriptions/plan',
          label: 'Subscription Plan',
        },
        {
          key: '/subscriptions/plan/addPlan',
          label: 'Add Subscription',
        },
      ],
    },
    {
      key: 'movies',
      icon: <VideoCameraOutlined />,
      label: 'Movies',
      children: [
        {
          key: '/Video/Show',
          label: 'Movies',
        },
        {
          key: '/Video/Show/addVideoShow',
          label: 'Add Movie',
        },
      ],
    },
    {
      key: 'series',
      icon: <PlayCircleOutlined />,
      label: 'Series',
      children: [
        {
          key: '/TvShows/Shows',
          label: 'Series',
        },
        {
          key: '/TvShows/Shows/addTvShow',
          label: 'Add Series',
        },
        {
          key: '/TvShows/episodes',
          label: 'Tv show Episodes',
        },
      ],
    },
    {
      key: 'payment',
      icon: <MoneyCollectOutlined />,
      label: 'Payment',
      children: [
        {
          key: '/payment/key',
          label: 'Payment key',
        },
        {
          key: '/payment/key/addKey',
          label: 'Add Payment key',
        },
      ],
    },
    {
      key: 'media-data',
      icon: <FileExcelOutlined />,
      label: 'Media Data',
      children: [
        {
          key: '/media-data/mec',
          label: 'Media Entertainment Core (MEC)',
        },
        {
          key: '/media-data/mmc',
          label: 'Media Manifest Core (MMC)',
        },
      ],
    },
    {
      key: '/excelData',
      icon: <FileExcelOutlined />,
      label: 'excelData',
    },
    {
      key: '/registerUsers',
      icon: <FileExcelOutlined />,
      label: 'registerUsers',
    },
    {
      key: '/transactions',
      icon: <MoneyCollectOutlined />,
      label: 'Transactions',
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: 'Settings',
      children: [
        {
          key: '/settings/global_settings',
          label: 'Global Settings',
        },
        {
          key: '/settings/private_settings',
          label: 'Private Settings',
        },
      ],
    },
  ];

  const handleMenuClick = ({ key }) => {
    navigate(key);
  };

  const getSelectedKeys = () => {
    const path = location.pathname;
    return [path];
  };

  const getOpenKeys = () => {
    const path = location.pathname;
    const openKeys = [];
    
    // Find parent keys for nested routes
    menuItems.forEach(item => {
      if (item.children) {
        item.children.forEach(child => {
          if (child.key === path) {
            openKeys.push(item.key);
          }
        });
      }
    });
    
    return openKeys;
  };

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      width={256}
      style={{
        background: '#001529',
        boxShadow: '2px 0 6px rgba(0, 21, 41, 0.35)',
        zIndex: 10,
      }}
    >
      <div style={{
        height: 64,
        position: 'relative',
        lineHeight: '64px',
        paddingLeft: 24,
        transition: 'all 0.3s',
        overflow: 'hidden',
        background: '#002140',
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          color: '#fff',
        }}>
          <img
            src="/logo.png"
            alt="Logo"
            style={{
              width: 32,
              height: 32,
              display: 'inline-block',
              verticalAlign: 'middle',
            }}
          />
          {!collapsed && (
            <Title
              level={4}
              style={{
                color: '#fff',
                fontSize: 20,
                margin: '0 0 0 12px',
                fontFamily: '"Myriad Pro", "Helvetica Neue", Arial, Helvetica, sans-serif',
                fontWeight: 600,
                display: 'inline-block',
                height: 32,
                lineHeight: '32px',
                verticalAlign: 'middle',
              }}
            >
              OTT
            </Title>
          )}
        </div>
      </div>
      
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={getSelectedKeys()}
        defaultOpenKeys={getOpenKeys()}
        items={menuItems}
        onClick={handleMenuClick}
        style={{
          padding: '16px 0',
        }}
      />
      
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: 48,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#001529',
          borderTop: '1px solid #1f1f1f',
        }}
      >
        {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
          style: {
            fontSize: 16,
            color: '#fff',
            cursor: 'pointer',
          },
          onClick: onCollapse,
        })}
      </div>
    </Sider>
  );
};

export default Sidebar;
